$(document).ready(function () {
  $(".quick-view").on('click', function () {
    $.fancybox.open({
      src: '#quick-view',
      type: 'inline',
      opts: {
        beforeLoad: beforeloadpopup($(this)),
        afterShow: afterShowpopup
      } 
    });
	
  });
  function afterShowpopup(){
  }
  function beforeloadpopup($this){
  	var product_handle = $this.data('handle');
    $('#quick-view').addClass(product_handle);
    $('#quick-view').html(content);
    
    jQuery.getJSON('/products/' + product_handle + '.js', function (product) {
      var title = product.title;
      var type = product.type;
      var price = 0;
      var original_price = 0;
      var desc = product.description;
      var images = product.images;
      var variants = product.variants;
      var options = product.options;
      var url = '/products/' + product_handle;
      $('.qv-product-title').text(title);
      $('.qv-product-type').text(type);
      $('.qv-product-description').html(desc);
      $('.view-product').attr('href', url);
      var imageCount = $(images).length;
      $(images).each(function (i, image) {
        if (i == imageCount - 1) {
          var image_embed = '<div><img src="' + image + '"></div>';
          image_embed = image_embed.replace('.jpg', '_800x.jpg').replace('.png', '_800x.png');
          $('.qv-product-images').append(image_embed);
          $('.qv-product-images').slick({
            'dots': false,
            'arrows': true,
            'respondTo': 'min',
            'useTransform': false
          }).css('opacity', '1');
        } else {
          image_embed = '<div><img src="' + image + '"></div>';
          image_embed = image_embed.replace('.jpg', '_800x.jpg').replace('.png', '_800x.png');
          $('.qv-product-images').append(image_embed);
        }
      });
      $(options).each(function (i, option) {
        var opt = option.name;
        var selectClass = '.option.' + opt.toLowerCase();
        $('.qv-product-options').append('<div style="display:none;" class="option-selection-' + opt.toLowerCase() + '"><span class="option">' + opt + '</span><select class="option-' + i + ' option ' + opt.toLowerCase() + '"></select></div>');
        $(option.values).each(function (i, value) {
          $('.option.' + opt.toLowerCase()).append('<option value="' + value + '">' + value + '</option>');
        });
      });
      $(options).each(function (i, option) {
        var opt = option.name;
        var selectClass = '.option.' + opt.toLowerCase();
        if(opt == "Color")
        {
          $('.qv-product-options').append('<div class="ProductForm__Option ProductForm__Option--labelled option-selection-' + opt.toLowerCase() + '"><span class="option">' + opt + '</span><ul class="ColorSwatchList HorizontalList Swatch_color HorizontalList--spacingTight option-' + i + ' option ' + opt.toLowerCase() + '"></ul></div>');
          $(option.values).each(function (i, value) {
            if(value == "white"){
              var ans = "ColorSwatch--white";
            }
            $('.option.' + opt.toLowerCase()).append('<li class="HorizontalList__Item" value="' + value + '"><input id="option-0-' + i + '" class="ColorSwatch__Radio" type="radio" name="option-0" value="' + value + '" data-option-position="1"><label for="option-0-' + i + '" class="ColorSwatch ColorSwatch--large '+ans+'"  data-tooltip=" '+ value + '" style="background-color:'+ value + '"><span class="u-visually-hidden">' + value + '</span></label></li>');
          });
        }
        else
        {
          $('.qv-product-options').append('<div class="ProductForm__Option ProductForm__Option--labelled option-selection-' + opt.toLowerCase() + '"><span class="option">' + opt + '</span><ul class="SizeSwatchList HorizontalList Swatch_size HorizontalList--spacingTight option-' + i + ' option ' + opt.toLowerCase() + '"></ul></div>');
          $(option.values).each(function (i, value) {
            $('.option.' + opt.toLowerCase()).append('<li class="HorizontalList__Item" value="' + value + '"><input id="option-1-' + i + '" class="SizeSwatch__Radio" type="radio" name="option-1" value="' + value + '"  data-option-position="2"><label for="option-1-' + i + '" class="SizeSwatch">' + value + '</label></li>');			
          });
        }
      });
      $(product.variants).each(function (i, v) {
        if (v.inventory_quantity == 0) {
          $('.qv-add-button').prop('disabled', true).val('Sold Out');
          $('.qv-add-to-cart').hide();
          $('.qv-product-price').text('Sold Out').show();
          return true
        } else {
          price = parseFloat(v.price / 100).toFixed(2);
          original_price = parseFloat(v.compare_at_price / 100).toFixed(2);
          $('.qv-product-price').text('$' + price);
          if (original_price > 0) {
            $('.qv-product-original-price').text('$' + original_price).show();
          } else {
            $('.qv-product-original-price').hide();
          }
          $('ul.ColorSwatchList.HorizontalList.HorizontalList--spacingTight.option-0').val(v.option1);
          $('ul.SizeSwatchList.HorizontalList.HorizontalList--spacingTight.option-1').val(v.option2);
          //          $('ul.ColorSwatchList.HorizontalList.HorizontalList--spacingTight.option-2').val(v.option3);
          return false
        }
      });
      
      $(document).on("change", "#quick-view .ColorSwatch__Radio", function () {
        var value = $(this).val();
        $(".color").val($(this).val());
        $(this).closest( ".qv-product-options" ).find('.Swatch_color').find("input[value=" + value + "]").prop('checked', true);
        if ($(".color").val() == $(this).val()){
        }
        else{
          $(this).parent().find(".ColorSwatch").removeClass("sdsds");
        }
      });
      $(document).on("change", "#quick-view .SizeSwatch__Radio", function () {
        $(".size").val($(this).val());
        var value = $(this).val();
        $(this).closest( ".qv-product-options" ).find('.Swatch_size').find("input[value=" + value + "]").prop('checked', true);
      });
      $(document).on("change", "#quick-view select", function () {
        var selectedOptions = '';
        $('#quick-view select').each(function (i) {
          if (selectedOptions == '') {
            selectedOptions = $(this).val();
          } else {
            selectedOptions = selectedOptions + ' / ' + $(this).val();
          }
        });
        jQuery.getJSON('/products/' + product_handle + '.js', function (product) {
          $(product.variants).each(function (i, v) { 
            if (v.title == selectedOptions) {
              var price = parseFloat(v.price / 100).toFixed(2);
              var original_price = parseFloat(v.compare_at_price / 100).toFixed(2);
              var v_qty = v.inventory_quantity;
              var v_inv = v.inventory_management;
              $('.qv-product-price').text('$' + price);
              $('.qv-product-original-price').text('$' + original_price);
              if (v_inv == null) {
                $('.qv-add-button').prop('disabled', false).val('Add to Cart');
              } else {
                if (v.inventory_quantity < 1) {
                  $('.qv-add-button').prop('disabled', true).val('Sold Out');
                } else {
                  $('.qv-add-button').prop('disabled', false).val('Add to Cart');
                }
              }
            }
          });
        });
      });
      
      $(document).on("click", ".qv-add-button", function () {
          var qty = $('.qv-quantity').val();
          var selectedOptions = '';
          var var_id = '';
          $('#quick-view select').each(function (i) {
            if (selectedOptions == '') {
              selectedOptions = $(this).val();
            } else {
              selectedOptions = selectedOptions + ' / ' + $(this).val();
            }
          });
          jQuery.getJSON('/products/' + product_handle + '.js', function (product) {
            $(product.variants).each(function (i, v) {
              if (v.title == selectedOptions) {
                var_id = v.id;
                processCart();
              }
            });
          });
          function processCart() {
            jQuery.post('/cart/add.js', {
              quantity: qty,
              id: var_id
            },
                        null,
                        "json"
                       ).done(function () {
              $('.qv-add-to-cart-response').addClass('success').html('<span>' + $('.qv-product-title').text() + ' has been added to your cart. <a href="/cart">Click here to view your cart.</a>');
            })
            .fail(function ($xhr) {
              var data = $xhr.responseJSON;
              $('.qv-add-to-cart-response').addClass('error').html('<span><b>ERROR: </b>' + data.description);
            });
          }
        });
        $('.fancybox-wrap').css('overflow', 'hidden !important');
    });
  }
});